import React from 'react'
import { OverlayTrigger, Tooltip, Tab, Tabs, Table } from 'react-bootstrap'

const Interaction = ({ title, data, brandArr }) => {
  // 將 data 中的值更新至 powerdata 中的 count 值
  // for (let i = 0; i < powerData.length; i++) {
  //   if (powerData[i].id === Object.keys(data)[i]) {
  //     let newCount = Object.values(data)[i]
  //     powerData[i].count = newCount
  //   }
  // }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      這個指標可以幫助您了解您的社群內容是否有效地吸引和連結受眾。
    </Tooltip>
  )

  // let fbData = powerData.slice(0, 5)
  // let igData = powerData.slice(5, 10)
  // let ytData = powerData.slice(10, 15)

  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>
      <Tabs
        defaultActiveKey="Facebook"
        id="justify-tab"
        className="mb-3"
        justify
      >
        {brandArr.map((v, i) => {
          return (
            <Tab key={i} eventKey={v.title} title={v.title}>
              <Table striped hover>
                <tbody>
                  <tr>
                    <td>貼文平均讚數</td>
                    <td>{data['mean_like_' + v.brand]}</td>
                  </tr>
                  <tr>
                    <td>貼文平均留言數</td>
                    <td>{data['mean_comment_' + v.brand]}</td>
                  </tr>
                  <tr>
                    <td>貼文平均分享數</td>
                    <td>{data['mean_share_' + v.brand]}</td>
                  </tr>
                  <tr>
                    <td>貼文平均觸及數</td>
                    <td>{data['mean_touch_' + v.brand]}</td>
                  </tr>
                  <tr>
                    <td>影片平均觀看數</td>
                    <td>{data['mean_watch_' + v.brand]}</td>
                  </tr>
                </tbody>
              </Table>
            </Tab>
          )
        })}
      </Tabs>
    </>
  )
}

export default Interaction
